import axios from 'axios';
import { setupInterceptors } from './api-admin-interceptors';

let API = axios.create({
  baseURL: `${process.env.VUE_APP_API}/api/v2/admin/`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
});

setupInterceptors(API);

export default API;
